
import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {getAccountAssets, transferAsset} from '../common/ardorinterface';
import {validateAddress,validatePassPhrase,validateQuantity} from '../common/validators';

import {SignActionField} from '../common/signactionfield';
import {QrAccountField} from '../common/accountfield';
import { Typography } from '@material-ui/core';
import {TxSuccess} from '../common/txsuccess';
import { REFERRALASSET } from '../common/constants';


export function SendForm(props){
  return(
    <form onSubmit={(event)=>{event.preventDefault();props.handleSendCard()}}>
      <Grid container
        justify="center"
        alignItems="stretch"
        direction="column" 
        spacing={24} 
      >
        <Grid item>
          <Typography variant="h4">Send REFs</Typography>       
        </Grid>
        <Grid item>
          <TextField fullWidth 
                  invalid={props.noCardsStatus.invalid} 
                  type="number" 
                  name="noCards"
                  label={"Number of REFs (max: "+props.asset.quantityQNT+")"}
                  variant="outlined"
                  InputLabelProps={{
                    type:"number",
                    shrink: true
                  }}
                  id="noCards" onChange={(event) => props.handleNoCardsChange(event)}
                  value={props.noCards}
                  placeholder="Number of REFs you want to send" />
          <Typography>{props.noCardsStatus.error}</Typography>
        </Grid>
        <Grid item>
          <QrAccountField value={props.receiverRS} 
                          status={props.receiverRsStatus} 
                          onChange={props.handleReceiverRsChange}>
          Recipient
          </QrAccountField>             
        </Grid>
        <Grid item>
          <SignActionField  {...props} gameaction="sendCard"
                            action={props.handleSendCard}
                            />
        </Grid>      
      </Grid>
    </form>
  )
}



export class SendRefs extends Component {
  constructor (props){
    console.log(props);
    super(props);
    this.state = {
      asset:{},
      noCards:1,
      noCardsStatus:{invalid:false,error:''},
      passPhrase:"",
      passPhraseStatus:{invalid:undefined,error:''},
      receiverRS:"",
      receiverRsStatus:{invalid:undefined,error:''},
      message:"not yet implemented",
      displayQrReader:false
    };
    this.sendAsset = this.sendAsset.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  refresh(){
    var self = this;
    getAccountAssets(self.props.nodeurl,self.props.user.accountRs,REFERRALASSET)
    .then(function(response){
      if (Object.keys(response).length===0) {//empty object -> asset not in account
          self.setState({asset:{quantityQNT:0,unconfirmedQuantityQNT:0}});
      }
      else {
          self.setState({asset:response});
      }
    });
  }

  componentDidMount(){
    this.refresh();
    this.timer = setInterval(this.refresh,9000);
  }

  componentWillUnmount(){
    clearInterval(this.timer);
  }


  sendAsset(event) {
      var self = this;
      console.log(self);
      let phraseValidated = validatePassPhrase(self.state.passPhrase,self.state.passPhraseStatus,self.props.user.accountRs);
      if  (phraseValidated.invalid){
        console.log("sendAsset(): passphrase invalid, exiting.")
        self.setState({passPhraseStatus:phraseValidated},this.validateForm);
        return;
      }
      console.log("sendAsset(): passphrase ok.")
      console.log('send '+self.state.noCards+' cards.');
      console.log('get publicKey');
      
      transferAsset(self.props.nodeurl,self.state.asset.asset,self.state.noCards,self.state.receiverRS,self.state.passPhrase)
      .then(function(response) {
        self.setState({response:response,responseTime:response.data.requestProcessingTime,bought:true,status:"success"});
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  validateForm() {
    this.setState({formValid: (this.state.passPhraseStatus.invalid===false) && (this.state.noCardsStatus.invalid===false) && (this.state.receiverRsStatus.invalid===false)});
  }

  handlePassphraseChange(event){
    let value = event;
    this.setState(
      {passPhrase:value},
      ()=>{let fieldStatus = validatePassPhrase(value,this.state.passPhraseStatus);
            this.setState({passPhraseStatus:fieldStatus},this.validateForm);}
    );
  }

  handleNoCardsChange(event){
    let value = event.target.value;
    let max=this.state.asset.quantityQNT;
    let min=1;
    this.setState(
      {noCards:value},
      ()=>{let fieldStatus = validateQuantity(value,max,min,this.state.noCardsStatus);
            this.setState({noCardsStatus:fieldStatus},this.validateForm);}
    );
  }

  handleReceiverRsChange(value){
      //let value = event.target.value;
      this.setState(
          {receiverRS:value},
          ()=>{let fieldStatus = validateAddress(value,this.state.receiverRsStatus);
              this.setState({receiverRsStatus:fieldStatus},this.validateForm);}
      );
  }

  toggler(props){
    this.setState({bought:false});
    this.props.toggle(!this.props.modalOpen);
  }

  render(){
    //console.log(this.state);
    return(
      <div style={{textAlign:"center", width:"90%", display:"inline-block",   justifyContent:'center', alignItems:'center',  backgroundColor: '#1D1D1D', marginTop: 5,marginBottom: 5, border:'0px solid', borderColor:'#ffffff3b'}} >
        <Grid container
          justify="center"
          alignItems="stretch"
          direction="row"
          spacing={12}
          style={{
            marginTop: 5, 
            borderRadius:'10px',
            border:'1px solid',
            borderColor:'#ffffff10',
            boxShadow: "5px 5px 8px rgba(5, 5, 5, 0.32)"
            }}>
                  
          <Grid item className="boxed" style={{marginTop: 10, marginBottom:20, marginRight:5, backgroundColor:'rgb(29 29 29)', border:'0px solid', borderColor:'#ffffff3b'}}>
          { this.state.bought ? (
              <TxSuccess/>
            ):(
              <SendForm {...this.state}
                      {...this.props}
                      handleNoCardsChange={(event) => this.handleNoCardsChange(event)}
                      handlePassphraseChange={(event)=> this.handlePassphraseChange(event)}
                      handleReceiverRsChange={(event)=> this.handleReceiverRsChange(event)}
                      handleSendCard={()=>this.sendAsset()}
                      openQRCamera={this.openQRCamera}
                      handleToggle={this.toggler}
                      formValid={this.state.formValid}/>
            )
          }          
          </Grid>
        </Grid>
      </div>
    )
  }
}

